import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  ISearchFilterCommission,
  ICommissionInfo
} from './../../models/commission';
import { ApiDialogService } from './../../services/api/api-cdialog.service';
import { ApiCommissionService } from './../../services/api/api-commission.service';
import { HeaderTitle } from 'src/app/models/generic';
import { DataService } from 'src/app/services/data.service';
import { IDialogCommissionData } from 'src/app/models/dialog';

@Component({
  selector: 'app-comissao-faturamento',
  templateUrl: './comissao-faturamento.component.html',
  styleUrls: ['./comissao-faturamento.component.scss']
})
export class ComissaoFaturamentoComponent implements OnInit {
  commissionList: ICommissionInfo[] = [];
  count: number = 0;

  constructor(
    private _commissionService: ApiCommissionService,
    private _dataService: DataService,
    private _activatedRoute: ActivatedRoute
  ) {
    const title = _activatedRoute.snapshot.routeConfig?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
  }

  ngOnInit() {
    this.getAllCommissions();
  }

  getAllCommissions(): void {
    const searchFilter: ISearchFilterCommission = {
      Banks: [],
      Periods: [],
      Products: [],
      Text: '',
      Take: 10,
      Skip: 0
    };

    this._commissionService.getAllCommissions(searchFilter).subscribe({
      next: (response) => {
        this.commissionList = response.Data;
        this.count = response.Count;
      }
    });
  }
}
